<p>
  {{ 'STEP4.INTRODUCTIONTEXT' | translate }}
</p>
<div *ngIf="canDisableFloor">
  <div class="title">{{ 'STEP4.FLOORCHOICE' | translate }}</div>
  <div class="two-buttons">
    <app-isomasters-button (modularClick)="wantsFloor = true" [selected]="wantsFloor" class="left">
      <div second-content>
        <span *ngIf="pricesVisible && priceDifferenceForYesFloor" class="price-information">
          {{ priceDifferenceForYesFloor | plusMinPrice }}
        </span>
        &nbsp;
      </div>
      <div description>{{ 'YES' | translate }}</div>
    </app-isomasters-button>
    <app-isomasters-button (modularClick)="wantsFloor = false" [selected]="!wantsFloor">
      <div second-content>
        <span *ngIf="pricesVisible && priceDifferenceForNoFloor" class="price-information">
          {{ priceDifferenceForNoFloor | plusMinPrice }}
        </span>
        &nbsp;
      </div>
      <div description>{{ 'NO' | translate }}</div>
    </app-isomasters-button>
  </div>
</div>
<div [ngClass]="{ hidden: !wantsFloor }" class="optional">
  <div class="title">{{ 'STEP4.FLOORTYPE' | translate }}</div>
  <app-isomasters-horizontal-viewbox
    (optionSelected$)="processSelectedFloorType($event)"
    [options]="displayFloorTypes"></app-isomasters-horizontal-viewbox>
  <div class="floor-options">
    <app-isomasters-input
      (valueChange)="setPlinthsInside($event)"
      *ngIf="canHavePinths"
      [(value)]="plinthsInside"
      [type]="'checkbox'">
      <div content>{{ 'STEP4.PLINTHSINSIDE' | translate }}</div>
      <div *ngIf="pricesVisible" right-content>
        {{ priceDifferenceForPlinthsInside | plusMinPrice }}
      </div>
    </app-isomasters-input>
    <app-isomasters-input (valueChange)="setSunkenFloor($event)" [(value)]="sunkenFloor" [type]="'checkbox'">
      <div content>{{ 'STEP4.SUNKENFLOOR' | translate }}</div>
    </app-isomasters-input>

    <app-isomasters-input
      (valueChange)="setVentilationProfiles($event)"
      [(value)]="ventilationProfiles"
      [type]="'checkbox'">
      <div content>{{ 'STEP4.PROFILES' | translate }}</div>
      <div *ngIf="pricesVisible" right-content>
        {{ priceDifferenceForVentilationProfiles | plusMinPrice }}
      </div>
    </app-isomasters-input>
  </div>
</div>
